// extracted by mini-css-extract-plugin
module.exports = {"previews":"FileUpload-filePreviewer-previews-dd732aa6","previewPlaceholder":"FileUpload-filePreviewer-previewPlaceholder-fed225cf"};